import axios from "@/config/axios";
import type { App } from "vue";

export default {
  install: (app: App) => {
    app.config.globalProperties.$axios = axios;
    app.provide("axios", axios);
  },
};
